export const HOME_HIGHLIGHTS_UPLOAD_REQUEST = "HOME_HIGHLIGHTS_UPLOAD_REQUEST";
export const HOME_HIGHLIGHTS_UPLOAD_SUCCESS = "HOME_HIGHLIGHTS_UPLOAD_SUCCESS";
export const HOME_HIGHLIGHTS_UPLOAD_FAIL = "HOME_HIGHLIGHTS_UPLOAD_FAIL";

export const HOME_HIGHLIGHTS_FETCH_REQUEST = "HOME_HIGHLIGHTS_FETCH_REQUEST";
export const HOME_HIGHLIGHTS_FETCH_SUCCESS = "HOME_HIGHLIGHTS_FETCH_SUCCESS";
export const HOME_HIGHLIGHTS_FETCH_FAIL = "HOME_HIGHLIGHTS_FETCH_FAIL";

export const HOME_HIGHLIGHTS_DELETE_REQUEST = "HOME_HIGHLIGHTS_DELETE_REQUEST";
export const HOME_HIGHLIGHTS_DELETE_SUCCESS = "HOME_HIGHLIGHTS_DELETE_SUCCESS";
export const HOME_HIGHLIGHTS_DELETE_FAIL = "HOME_HIGHLIGHTS_DELETE_FAIL";